import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import { accountIcons } from 'images';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Input, Button, Dialog } from 'components/Ui';
import { createNote } from 'containers/PrimoAccount/actions';
import { selectDeliveryInstructionsStatus } from 'containers/PrimoAccount/selectors';
import thumbUp from 'images/ThumbUpGreen.svg';
import styles from './styles.scss';

const DeliveryInstructions = ({
  onClose,
  deliveryInstructionsStatus,
  ...props
}) => {
  const [message, setMessage] = useState('');
  const [isSendSuccessfully, setIsSendSuccessfully] = useState(false);

  useEffect(() => {
    setIsSendSuccessfully(deliveryInstructionsStatus.isSendSuccessfully);
  }, [deliveryInstructionsStatus.isSendSuccessfully]);

  useEffect(() => {
    setIsSendSuccessfully(false);
  }, []);

  const handleChange = ({ target: { value } }) => {
    setMessage(value);
  };

  const sendNote = () => {
    props.createNote({
      text: message,
      serviceType: 'water',
    });
  };

  const deliveryInstructionsForm = (
    <Fragment>
      <img src={accountIcons.MessageGreen} alt="message icon" />
      <span className={styles.title}>Leave your RSR delivery instructions</span>
      <span className={styles.text}>
        Help your Route Sales Representative put the products you love in the
        place that you’d like.
      </span>
      <ValidatorForm className={styles.form}>
        <Input
          placeholder="Type your message here…"
          multiline
          rows={5}
          value={message}
          onChange={handleChange}
        />
      </ValidatorForm>
      <div className={styles.buttons}>
        <Button
          type="button"
          onClick={onClose}
          text="Cancel"
          ariaLabel="cancel dialog"
          color="gray"
        />
        <Button
          text="Send"
          ariaLabel="send delivery instructions"
          disabled={!message}
          className={styles.send}
          onClick={sendNote}
          loading={deliveryInstructionsStatus.isSending}
        />
      </div>
    </Fragment>
  );

  const successMessage = (
    <Fragment>
      <img src={thumbUp} alt="" className={styles.icon} />
      Thanks! Your message has been sent.
    </Fragment>
  );

  const className = classnames(styles.container, {
    [styles.success]:
      isSendSuccessfully && !deliveryInstructionsStatus.isSending,
  });

  return (
    <Dialog
      onClose={onClose}
      open
      isCloseIcon={!isSendSuccessfully}
      size="small"
    >
      <div className={className}>
        {isSendSuccessfully && !deliveryInstructionsStatus.isSending
          ? successMessage
          : deliveryInstructionsForm}
      </div>
    </Dialog>
  );
};

DeliveryInstructions.propTypes = {
  onClose: PropTypes.func.isRequired,
  createNote: PropTypes.func.isRequired,
  deliveryInstructionsStatus: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
  deliveryInstructionsStatus: selectDeliveryInstructionsStatus(),
});

export default connect(mapStateToProps, { createNote })(DeliveryInstructions);
